import { useLayoutEffect, useRef, type CSSProperties, type ReactNode } from 'react'

/** ตำแหน่งประกายรอบกรอบ (x/y = % ของกรอบ · d = หน่วงเวลา · s = ขนาด) */
const SPARKS: Array<{ x: string; y: string; d: string; s: string }> = [
  { x: '-2%', y: '10%', d: '0s', s: '15px' },
  { x: '50%', y: '-1.5%', d: '.9s', s: '12px' },
  { x: '101%', y: '6%', d: '.4s', s: '17px' },
  { x: '102%', y: '46%', d: '1.5s', s: '12px' },
  { x: '-3%', y: '62%', d: '1.1s', s: '13px' },
  { x: '98%', y: '90%', d: '.2s', s: '15px' },
  { x: '8%', y: '99%', d: '1.8s', s: '12px' },
  { x: '56%', y: '100.5%', d: '.7s', s: '10px' },
]

/**
 * กรอบออร่าทองรอบป๊อปอัพสมาชิก (ป้ายประกาศ · ถุงทอง · รายการกิจกรรม)
 * แสงทองเรือง + เส้นขอบทองวิ่งรอบ + ประกายระยิบ — ตกแต่งล้วน (aria-hidden) · CSS ใน member-hub.css (.mh-aura)
 */
export function GoldAura({ children, closing = false, genieFrom = null }: { children: ReactNode; closing?: boolean; genieFrom?: { x: number; y: number } | null }) {
  const ref = useRef<HTMLDivElement>(null)
  // เอฟเฟกต์จินนี่: การ์ดพุ่งออกจาก/ถูกดูดกลับเข้า "จุดต้นทาง" (ถุงทอง) — วัดจากตำแหน่ง layout (ไม่รวม transform ของแอนิเมชัน)
  useLayoutEffect(() => {
    const el = ref.current
    if (!el || !genieFrom) return
    el.style.setProperty('--gdx', `${Math.round(genieFrom.x - (el.offsetLeft + el.offsetWidth / 2))}px`)
    el.style.setProperty('--gdy', `${Math.round(genieFrom.y - (el.offsetTop + el.offsetHeight / 2))}px`)
  }, [genieFrom])
  return (
    <div ref={ref} className={`mh-aura${genieFrom ? ' mh-aura--genie' : ''}${closing ? ' is-closing' : ''}`}>
      <span className="mh-aura-glow" aria-hidden="true" />
      {children}
      <span className="mh-aura-ring" aria-hidden="true" />
      {SPARKS.map((spark, i) => (
        <span
          key={i}
          className="mh-aura-spark"
          aria-hidden="true"
          style={{ '--x': spark.x, '--y': spark.y, '--d': spark.d, '--s': spark.s } as CSSProperties}
        >✦</span>
      ))}
    </div>
  )
}
